export default __webpack_public_path__ + "static/media/02.04.050.90c9f543.png";